<div class="row">
  <div class="position-fixed" style="z-index: 5;">
    <app-filtres-ticket 
    [collapseFromParent]="collapseFromParent" 
    (collapseCloseToparent)="getCollapseValue($event)"
    (onSubmitFilter)="getListTicketsSupport($event)" 
    (onPushFilters)="EmitFilterTickets($event)" 
    [filterSsearch]="filterSsearch">
    </app-filtres-ticket>
  </div>
</div>
<div class="row" #myDiv >
  <!-- Datatables -->
  <div class="col-lg-12 p-0">
    <div class="navbar-center row">


      <div class="col">
        <div class="row position-absolute flex-nowrap" style="right: 0px">
          <div class="col text-nowrap text-right mt-2">
            <p >{{'languages.listing.label_goto' | translate}}</p>
          </div>
          <div class="col mt-1 ml-2">
            <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48"
              (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;"
              size="1" class="page_input bg-white border rounded font-weight-bold" [value]="pages" max="{{totalPages}}">
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-4 border-0 border" >
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-3 ">
          <button type="button" class="btn-dt-add  ml-4" (click)="NavigateToAddTicket()" [attr.data-title]="'languages.ticket.addTicket' | translate">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
        <div class="col-6 blocDate mt-2">
          <div class="row d-flex justify-content-center align-items-center">
              <!-- <div class="col-5">
                  <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{'languages.listing.label_debutdate' | translate}}</mat-label>
                      <input matInput [matDatepicker]="pickerDebut" id="date_debut" name="date_debut" [(ngModel)]="date_debut" [value]="date_debut">
                      <mat-datepicker-toggle matSuffix [for]="pickerDebut"></mat-datepicker-toggle>
                      <mat-datepicker #pickerDebut></mat-datepicker>
                  </mat-form-field>
              </div>
              <div class="col-5">
                  <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{'languages.listing.label_enddate' | translate}}</mat-label>
                      <input matInput [matDatepicker]="pickerFin" id="date_fin" name="date_fin" [(ngModel)]="date_fin" [value]="date_fin | date:'yyyy-MM-dd'">
                      <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFin></mat-datepicker>
                  </mat-form-field>
              </div> -->
              <div class="col-2">    
<!--                 <img src="assets/icons/calendarListing.svg" class="mr-3" alt="">
 -->                <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M28.4162 5.93325V3.33325C28.4162 2.64992 27.8496 2.08325 27.1662 2.08325C26.4829 2.08325 25.9162 2.64992 25.9162 3.33325V5.83325H15.0829V3.33325C15.0829 2.64992 14.5162 2.08325 13.8329 2.08325C13.1496 2.08325 12.5829 2.64992 12.5829 3.33325V5.93325C8.08291 6.34992 5.89958 9.03325 5.56625 13.0166C5.53291 13.4999 5.93291 13.8999 6.39958 13.8999H34.5996C35.0829 13.8999 35.4829 13.4833 35.4329 13.0166C35.0996 9.03325 32.9162 6.34992 28.4162 5.93325Z" fill="#0B3757"/>
                  <path opacity="0.4" d="M35.4996 18.0632V20.9632C35.4996 21.9799 34.5996 22.7632 33.5996 22.5965C33.1329 22.5299 32.6496 22.4799 32.1662 22.4799C29.7364 22.4843 27.4074 23.4515 25.6893 25.1696C23.9712 26.8877 23.004 29.2168 22.9996 31.6466C22.9996 32.4132 23.2996 33.4799 23.6162 34.4465C23.7018 34.6976 23.7261 34.9655 23.6871 35.2279C23.6481 35.4903 23.5469 35.7396 23.3919 35.9549C23.237 36.1702 23.0328 36.3453 22.7963 36.4656C22.5599 36.5859 22.2982 36.648 22.0329 36.6466H13.8329C7.99957 36.6466 5.49957 33.3132 5.49957 28.3132V18.0465C5.49957 17.1299 6.24957 16.3799 7.16624 16.3799H33.8329C34.7496 16.3965 35.4996 17.1465 35.4996 18.0632Z" fill="#0B3757"/>
                  <path d="M32.1662 25.0001C28.4829 25.0001 25.4996 27.9834 25.4996 31.6667C25.4996 32.9167 25.8496 34.1001 26.4662 35.1001C27.0538 36.0876 27.8884 36.905 28.8878 37.472C29.8873 38.0389 31.0172 38.3358 32.1662 38.3334C34.5996 38.3334 36.7162 37.0334 37.8662 35.1001C38.4829 34.1001 38.8329 32.9167 38.8329 31.6667C38.8329 27.9834 35.8496 25.0001 32.1662 25.0001ZM35.6162 30.9501L32.0662 34.2334C31.8329 34.4501 31.5162 34.5667 31.2162 34.5667C30.8996 34.5667 30.5829 34.4501 30.3329 34.2001L28.6829 32.5501C28.4504 32.3149 28.3201 31.9975 28.3201 31.6667C28.3201 31.336 28.4504 31.0186 28.6829 30.7834C29.1662 30.3001 29.9662 30.3001 30.4496 30.7834L31.2496 31.5834L33.9162 29.1167C34.4162 28.6501 35.2162 28.6834 35.6829 29.1834C36.1496 29.6834 36.1162 30.4667 35.6162 30.9501ZM14.6662 25.0001C14.2329 25.0001 13.7996 24.8168 13.4829 24.5168C13.1829 24.2001 12.9996 23.7668 12.9996 23.3334C12.9996 22.9001 13.1829 22.4668 13.4829 22.1501C13.8662 21.7668 14.4496 21.5834 14.9996 21.7001C15.0996 21.7168 15.1996 21.7501 15.2996 21.8001C15.3996 21.8334 15.4996 21.8834 15.5996 21.9501L15.8496 22.1501C16.1496 22.4668 16.3329 22.9001 16.3329 23.3334C16.3329 23.7668 16.1496 24.2001 15.8496 24.5168L15.5996 24.7168C15.4996 24.7834 15.3996 24.8334 15.2996 24.8668C15.1996 24.9168 15.0996 24.9501 14.9996 24.9667C14.8829 24.9834 14.7662 25.0001 14.6662 25.0001ZM20.4996 25.0001C20.0662 25.0001 19.6329 24.8168 19.3162 24.5168C19.0162 24.2001 18.8329 23.7668 18.8329 23.3334C18.8329 22.9001 19.0162 22.4668 19.3162 22.1501C19.9496 21.5334 21.0662 21.5334 21.6829 22.1501C21.9829 22.4668 22.1662 22.9001 22.1662 23.3334C22.1662 23.7668 21.9829 24.2001 21.6829 24.5168C21.3662 24.8168 20.9329 25.0001 20.4996 25.0001ZM14.6662 30.8318C14.2329 30.8318 13.7996 30.6484 13.4829 30.3484C13.1829 30.0317 12.9996 29.5984 12.9996 29.1651C12.9996 28.7318 13.1829 28.2984 13.4829 27.9817C13.6496 27.8317 13.8162 27.7151 14.0329 27.6318C14.6496 27.3651 15.3829 27.5151 15.8496 27.9817C16.1496 28.2984 16.3329 28.7318 16.3329 29.1651C16.3329 29.5984 16.1496 30.0317 15.8496 30.3484C15.5329 30.6484 15.0996 30.8318 14.6662 30.8318Z" fill="#0B3757"/>
                  </svg>
                  
        </div>
            <div class="col-8">
            
                  <mat-form-field appearance="standard" class="w-100">
                    <mat-date-range-input [rangePicker]="picker"  >
                      <input matStartDate [(ngModel)]="date_debut" readonly placeholder="Date début "  (click)="openDatePicker()" />
                      <input matEndDate [(ngModel)]="date_fin" readonly placeholder="Date fin" (click)="openDatePicker()"/>
                      
                    </mat-date-range-input>
                    
                    <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="picker">    <mat-icon matDatepickerToggleIcon>
                      <img src="assets/icons/calendar.svg" > 
                    </mat-icon></mat-datepicker-toggle>
                    <img  class="remouveDate" matSuffix (click)="clearDateCreation()" src="assets/icons/delete-left.svg">
                    <mat-date-range-picker  [calendarHeaderComponent]="rangeDateCreation" #picker></mat-date-range-picker>
                  </mat-form-field>
               
              </div>
              <div class="col-2 w-100 pl-0 ">
                  <button type="button" class="filtrer" (click)=" filtrer()">
                    <img src="assets/icons/filtre.svg" class="mr-3" alt=""> 
                    <p class="m-0">{{'languages.buttons.filtrer' | translate}}</p>
    </button>
              </div>
          </div>
      </div>
        <div class="col-3 p-2  text-right">
          <input class="search" name="search" [(ngModel)]="search"  (input)="onInputChange($event.target.value)" placeholder="{{'languages.miniListing.search' | translate}}">
          <i aria-hidden="true" class="fa-solid fa-magnifying-glass icon-search fa-md"></i>
        </div>
        <!-- <div class="col-3  p-2 d-flex justify-content-center">
          <button class="filtreFavoris">
              <img class="mr-3" src="assets/icons/filtreFavoris.svg">
               b
          </button>
      </div> -->
      </div>
      <div class="row row-info">
        <div class="card-info-1" (click)="setStatusFilter('')">
          <p class="p-info-1">{{categorieTickets.totale}}</p>
          <p class="p-info-2"> {{'languages.ticket.label_total' | translate}}</p>
        </div>
        <div class="card-info-2" (click)="setStatusFilter('1')">
          <p class="p-info-1">{{categorieTickets.Declare}}</p>
          <p class="p-info-2"> {{'languages.ticket.label_declares' | translate}}</p>
        </div>
        <div class="card-info-3" (click)="setStatusFilter('3')">
          <p class="p-info-1">{{categorieTickets.Ferme_positif}}</p>
          <p class="p-info-2"> {{'languages.ticket.label_fermespositif' | translate}}</p>
        </div>
        <div class="card-info-4" (click)="setStatusFilter('4')">
          <p class="p-info-1">{{categorieTickets.Ferme_negatif}}</p>
          <p class="p-info-2">{{'languages.ticket.label_fermesnegatif' | translate}}</p>
        </div>
      </div>
      <div class="row">
        <button type="button" class="btn-dt-actions-groupee ml-4" (click)="actionGroupeTicket()"
          [disabled]="!actionButton"
          >
          {{'languages.groupedactions.groupedactions' | translate}}
        </button>
      </div>
      <div class="table-responsive p-3">
        <table class="table align-items-center">
          <thead class="head-table">
            <tr>
              <th>
                <input type="checkbox" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                
              </th>
              <th>

                {{'languages.listing.actions' | translate}}
              </th>
              <th (click)="setSortField('ticket_date_creation')">
                {{'languages.opportunite.label_creation' | translate}}
                <div class="sort-icon d-inline-block" [ngClass]="{'sort-active': sort_field=='ticket_date_creation'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='ticket_date_creation'}">
               
                  <i class="fa-solid fa-arrow-down-short-wide fa-lg"></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_user_creat')">{{'languages.opportunite.label_prospect' | translate}}
                <div class="sort-icon d-inline-block" [ngClass]="{'sort-active': sort_field=='prospect'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='prospect'}">
                 
                  <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_opportunite')">
                {{'languages.listing.oppAff' | translate}}
                <div class="sort-icon d-inline-block" [ngClass]="{'sort-active': sort_field=='opportunité'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='opportunité'}">
                  <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_user_affect')">{{'languages.alerts.affectedTo'
                | translate}}
                <div class="sort-icon d-inline-block" [ngClass]="{'sort-active': sort_field=='User affecté'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='User affecté'}">
                  <i class="fa-solid fa-arrow-down-short-wide fa-lg "></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_titre')">{{'languages.alerts.subject' |
                translate}}
                <div class="sort-icon  d-inline-block" [ngClass]="{'sort-active': sort_field=='sujet'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='sujet'}">
                <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_categorie')">{{'languages.ticket.Category' |
                translate}}
                <div class="sort-icon  d-inline-block" [ngClass]="{'sort-active': sort_field=='catégorie'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='catégorie'}">
                <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th>
              <th (click)="setSortField('ticket_statut')">
                {{'languages.opportunite.label_status' | translate}}
                <div class="sort-icon" style="display: inline-block;" [ngClass]="{'sort-active': sort_field=='statut'}"
                  [ngClass]="{'sort-up': !sort_value && sort_field=='statut'}">
                <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="body-table">
            <tr *ngFor="let ticket of ticketsSupport; let i = index">
              <td>
                <div class="pt-1">
                  <label class="container">
                    <input type="checkbox" [(ngModel)]="ticket.isSelected" name="list_name"
                      value="{{ticket.id_ticket}}" (change)="isAllSelected()">
                  </label>


                </div>
              </td>
              <td>

                <a type="button" class="btn-dt-list" (click)="NavigateToTicketDetails(ticket.id_ticket)"
                  >
                  <img src="/assets/icons/edit-icon.svg">
                </a>
              </td>
              <td>
                <p>{{ticket.ticket_date_creation}}</p>
                <p>{{ticket.ticket_createur_name}}</p>
              </td>
              <td>
                <p>{{ ticket?.prospect_full_name || '-' }}</p>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <div *ngIf="ticket.id_affaire_ticket">
                    <a type="button" class="btn-dt-link text-left" target="_blank"
                      href="/affaires/details/{{ticket.id_affaire_ticket}}">
                      <i class="fa-solid fa-link fa-icon-style"></i>
                    {{'languages.listing.Affaire' | translate}}
                    </a>
                  </div>
                  <div *ngIf="ticket.id_opportunite">
                    <a type="button" class="btn-dt-link text-left pl-2" target="_blank"
                      href="/opportunities/details/{{ticket.id_opportunite}}">
                      <i class="fa-solid fa-link fa-icon-style"></i>
                   {{'languages.listing.Opportunite' | translate}}
                    </a>
                  </div>
                </div>
              </td>
              <td>
                <p>{{ticket.ticket_affect_full_name}}</p>
              </td>
              <td>
                <p>{{expandFileName(ticket.ticket_titre)}}</p>
              </td>
              <td>
                <p>{{ticket.categorie_libelle}}</p>
              </td>

              <td>

                <!--    -->
                <div class="label-status" [ngStyle]="{'background':ticket.statut_libelle[0]?.background_color}">
                  <span class="pt-2 " [ngStyle]="{'color':ticket.statut_libelle[0]?.color}">
                    {{ticket.statut_libelle[0].libelle.split('(')[0].trim()}}
                  </span>
                </div>

              </td>
            </tr>
          </tbody>
        </table>
        <div class="row d-flex justify-center align-items-center text-center ">
          <p *ngIf="ticketsSupport?.length===0"  class="col-12 noTicket">  {{'languages.ticket.noTicket' | translate}} </p>
         </div>
      </div>
    </div>
    <div class="navbar-center mb-4 row">
      <div class="col pt-1">
        <div class="row w-50 flex-nowrap" >
          <div  class="col mt-1">
            <p>{{'languages.miniListing.Afficher' | translate}}</p>
          </div>
          <div class="col mx-1">
            <select [(ngModel)]="limit" (change)="updateListTickets()"
              class="bg-white border pt-1 rounded font-weight-bold">
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div class="col mt-1">
            <p class="text-nowrap">{{'languages.miniListing.pagesPerPage' | translate}} {{totalLength}} {{'languages.miniListing.element' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="col-8">
        <nav aria-label="Page navigation example" *ngIf="totalPages>0">
          <ul class="pagination pg-blue">
            <li (click)="first()" class="page-item" [ngClass]="{'disabled':isFirst()}">
              <a class="page-link-symbol">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li *ngIf="!isFirst()" (click)="prev()" class="page-item mx-2">
              <a class="page-link-symbol-chevron" aria-label="Previous">
                <i class="fa fa-chevron-left "></i>
              </a>
            </li>
            <ng-container *ngFor="let item of [].constructor(3); let i = index">
              <li *ngIf="i+pages-3>0" class="page-item">
                <a (click)="changepage(i+pages-3)" class="page-link mt-2 border rounded">{{i + pages - 3}}</a>
              </li>
            </ng-container>
            <ng-container *ngFor="let item of [].constructor(3); let i = index">
              <li *ngIf="i+pages<totalPages" class="page-item">
                <a (click)="changepage(i+pages)" class="page-link mt-2 border rounded"
                  [ngClass]="{'active-page':pages==(i+pages)}">
                  {{i + pages}}
                </a>
              </li>
            </ng-container>
            <li *ngIf="totalPages>1 && totalPages > 3 " class="m-2"> ... </li>
            <li class="page-item">
              <a (click)="changepage(totalPages)" class="page-link mt-2 border rounded"
                [ngClass]="{'active-page':pages==totalPages}">{{totalPages}}</a>
            </li>
            <li *ngIf="!isLast()" (click)="next()" class="page-item mx-2">
              <a class="page-link-symbol-chevron" aria-label="Next">
                <i class="fa fa-chevron-right"></i>
              </a>
            </li>
            <li (click)="last()" class="page-item" [ngClass]="{'disabled':isLast()}">
              <a class="page-link-symbol">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col">
        <div class="row position-absolute flex-nowrap" style="right: 0px">
          <div class="col text-nowrap text-right mt-2">
            <p >{{'languages.listing.label_goto' | translate}}</p>
          </div>
          <div class="col mt-1 ml-2">
            <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48"
              (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;"
              size="1" class="page_input bg-white border rounded font-weight-bold" [value]="pages" max="{{totalPages}}">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
